import './FoundersClub.css';
import { useState } from 'react';
import qintoDownloadQR from '../../assets/qinto_download_qr_design.png';
import foundersClubImage from '../../assets/founders_club_square.png';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from '../../modals/LoginModal/LoginModal';

export const FoundersClub = () => {
  const { currentUser } = useAuth();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const handleJoinEarlyAccessClick = () => {
    if (!currentUser) {
      setIsLoginModalOpen(true);
    }
  };

  return (
    <section className="founders-club">
      <div className="container founders-grid">

        {/* Left: Visual */}
        <div className="founders-visual fade-in-section is-visible">
          <img
            src={foundersClubImage}
            alt="Qinto Founders Club"
            className="founders-image"
          />
        </div>

        {/* Right: Content */}
        <div className="founders-content fade-in-section is-visible">
          <h2 className="founders-title">
            Join the Founders Club
          </h2>

          <p className="founders-subtitle">
            Be among the first to shape the future of local buying & selling.
          </p>

          <ul className="founders-benefits">
            <li>✨ Exclusive benefits to first 200 users.</li>
            <li>🏷️ Permanent <strong>Founder</strong> badge on your profile</li>
            <li>🚀 2 FREE boosts to move your listings back to the top</li>
            <li>💬 Direct voice in shaping Qinto’s features</li>
          </ul>

          <a
            href="https://play.google.com/store/apps/details?id=com.qinto.qintoapp"
            target="_blank"
            rel="noopener noreferrer"
            className="founders-cta"
          >
            Download the app now
          </a>

          {!currentUser && (
            <button
              onClick={handleJoinEarlyAccessClick}
              target="_blank"
              rel="noopener noreferrer"
              className="founders-cta-1"
            >
              Join early access
            </button>
          )}

          <p className="founders-note">
            Limited spots • Early members only • T&C Apply
          </p>
        </div>

      </div>

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </section>
  );
};
